import { Button, Modal } from "antd";
import { checkPermissionAction } from "../../utils/helper/utils";

const ZonesPolygons = ({ permissionJson, handleCancel, isModalOpen, saveEdits, mapRef })=> {

    return (
        <Modal
            title="Zone Map"
            open={isModalOpen}
            onCancel={handleCancel}
            footer={[
              <Button key="cancel" onClick={handleCancel} className="border-gray-300 text-gray-700 hover:text-gray-900">
                Cancel
              </Button>,
              checkPermissionAction?.("Zones", permissionJson, "edit") ? (
                <Button key="save" type="primary" onClick={saveEdits}>
                  Save Changes
                </Button>
              ) : null,
            ]}
            width="100%"
            style={{ top: 0, margin: 0 }}
            bodyStyle={{ height: "calc(100vh - 110px)", overflow: "hidden", padding: 0 }}
            className="max-w-full"
          >
            <div ref={mapRef} style={{ width: "100%", height: "100%" }} />
          </Modal>
    )
}

export default ZonesPolygons;